function backupEventAction(boxGroup) {
  if (boxGroup === 'BACKUPS') {
    return 'Backup_browsing';
  } else if (boxGroup === 'ARCHIVES') {
    return 'Archive_browsing';
  } else if (boxGroup === 'SYNC') {
    return 'Sync_browsing';
  }

  console.log('Undefined box group', boxGroup);
  return 'Undefined_browsing';
}

export default backupEventAction;
